import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline"
import EditOutlinedIcon from "@mui/icons-material/EditOutlined"
import IconButton from "@mui/material/IconButton"
import Tooltip from "@mui/material/Tooltip"
import PropTypes from "prop-types"

import Row from "../../../common/components/Row"

export default function AdminCallingNumberRowActions({
  row,
  onEdit,
  onDelete,
}) {
  return (
    <Row gap={0.5} justifyContent="flex-end">
      <Tooltip title="Edit number">
        <IconButton
          size="small"
          aria-label="Edit calling number"
          onClick={() => onEdit(row)}
        >
          <EditOutlinedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Tooltip title="Release from Twilio">
        <IconButton
          size="small"
          color="error"
          aria-label="Remove calling number"
          onClick={() => onDelete(row)}
        >
          <DeleteOutlineIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Row>
  )
}

AdminCallingNumberRowActions.propTypes = {
  row: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
}
